import { Injectable, computed, inject, signal } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class UserAvatarService {
  private readonly auth = inject(AuthService);
  private readonly customAvatarUrl = signal<string | null | undefined>(undefined);
  private readonly customBroken = signal(false);
  private readonly providerBroken = signal(false);

  readonly effectiveUrl = computed(() => {
    const custom = this.customAvatarUrl();
    if (typeof custom === 'string' && custom.length > 0 && !this.customBroken()) {
      return custom;
    }

    if (!this.providerBroken()) {
      return this.auth.getProfilePictureUrl();
    }

    return undefined;
  });

  setCustomAvatarUrl(url: string | null | undefined, bustCache = false): void {
    const normalized = url && url.length > 0 ? url : null;
    this.customAvatarUrl.set(normalized && bustCache ? this.withCacheBust(normalized) : normalized);
    this.customBroken.set(false);
    this.providerBroken.set(false);
  }

  markBroken(): void {
    const custom = this.customAvatarUrl();
    if (typeof custom === 'string' && custom.length > 0 && !this.customBroken()) {
      this.customBroken.set(true);
      return;
    }

    this.providerBroken.set(true);
  }

  private withCacheBust(url: string): string {
    try {
      const parsed = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
      parsed.searchParams.set('v', String(Date.now()));
      if (/^https?:\/\//i.test(url)) {
        return parsed.toString();
      }

      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
      const separator = url.includes('?') ? '&' : '?';
      return `${url}${separator}v=${Date.now()}`;
    }
  }
}
